import styled from "@emotion/styled";
import React from "react";

const HorizontalMargin = styled.span`
  display: flex;
  width: ${({ margin }: any) =>
    typeof margin === "string" ? margin : `${margin}px`};
`;

const VerticalMargin = styled.span`
  display: flex;
  height: ${({ margin }: any) =>
    typeof margin === "string" ? margin : `${margin}px`};
`;

function Marginer(props: any) {
  const { direction } = props;

  if (direction === "horizontal") return <HorizontalMargin {...props} />;
  else {
    return <VerticalMargin {...props} />;
  }
}

Marginer.defaultProps = {
  direction: "horizontal",
};

export { Marginer };